<template>
<div class="mailbox">
  <h2
  v-if="!detailView"
  class="recent">Messages</h2>
  <p v-if="!messages[0]">No messages</p>
  <div
    v-if="!detailView">
    <div
      v-for="message in messages"
      :key="message.id"
      class="card"
    >
      <div @click="showDetail(message)">
        <div class="title-snip flex">
          <h3>{{ message.name }}</h3>
          <h3>{{ message.title }}</h3>
          <span>{{ message.createdAt.toDate().toLocaleDateString('en-us', dateOptions) }}</span>
        </div>
        <p>{{ message.message.substring(0, 40) + '... ' }}</p>
      </div>
    </div>
  </div>
  <div
  v-if="detailView">
    <mailbox-detail
      :message="singleMessage"
      @backDel="comeBack"/>
  </div>
</div>
</template>

<script>
import { ref } from '@vue/reactivity'
import MailboxDetail from './MailboxDetail.vue'
export default {
  components: { MailboxDetail },
  props: ['messages'],
  emits: ['messagedeleted'],
  setup (props, context) {
    const detailView = ref(false)
    const singleMessage = ref(null)
    const dateOptions = ref({ year: 'numeric', month: 'short', day: 'numeric' })

    const showDetail = (selectedMessage) => {
      detailView.value = !detailView.value
      singleMessage.value = selectedMessage
    }
    const comeBack = () => {
      detailView.value = !detailView.value
    }
    return { dateOptions, detailView, showDetail, singleMessage, comeBack }
  }
}
</script>

<style>
  .recent {
      color: black;
      margin-top: 0;
      margin-bottom: 5px;
    }
  .mailbox h3 {
      color: black;
    }
  .mailbox p {
      margin: 5px auto;
    }
  .mailbox .card {
    background: white;
    width: 95%;
    margin: 10px auto;
    cursor: pointer;
    border-radius: 15px;
  }
  .mailbox .title-snip {
    justify-content: space-around;
  }
</style>
